import { Link, LinkProps, mergeClasses } from '@fluentui/react-components';
import { OpenRegular } from '@fluentui/react-icons';

import { useExternalLinkStyles } from './EnhancedExternalLink.styles';

export type ExternalLinkProps = {
  iconClassName?: string
} & LinkProps & { as?: 'a' };

const EnhancedExternalLink: React.FC<ExternalLinkProps> = (props: ExternalLinkProps) => {
  const { className, iconClassName, children, ...otherProps } = props;
  const classes = useExternalLinkStyles();

  return (
    <Link className={mergeClasses('external-link', classes.container, className)} target="_blank" {...otherProps}>
      {children}
      <OpenRegular className={mergeClasses('icon', classes.icon, iconClassName)} />
    </Link>
  );
};

export default EnhancedExternalLink;
